
import React from "react";
import { ITournamentEditionMatchResultProof } from "../../../../../services";
import { i18nManager } from "../../../../../i18n";
import { BoolHelper, Classname, FileInputPreviewType } from "@rivtn/noseur";

export interface ResultProofProps {
    accept?: () => void;
    remove?: () => void;
    preview: () => void;
    isManaging?: boolean;
    isAccepted?: boolean;
    isAcceptedPreview?: boolean;
    proof: ITournamentEditionMatchResultProof;
}

function ResultProof(props: ResultProofProps) {

    const { proof, isManaging, isAccepted, isAcceptedPreview } = props;
    const labels = i18nManager.Labels.tournaments.your_tournament.matches_and_reporting.match.result;

    return (<div className="ma-proof">
        <div className="i">
            <i className="fa fa-file" />
        </div>
        <div className="info">
            <span className="n">
                <span className="lined-limit">{proof.name} {(isAcceptedPreview && proof.participant_name) && (<span style={{ opacity: 0.5 }}>({proof.participant_name})</span>)}</span>
                <div className="ctrl">
                    <span className="link" onClick={props.preview}>
                        {(proof.type === FileInputPreviewType.IMAGE) && (labels.view)}
                        {(proof.type === FileInputPreviewType.AUDIO) && (labels.listen)}
                        {(proof.type === FileInputPreviewType.VIDEO) && (labels.watch)}
                        {(!BoolHelper.equalsAny(proof.type, [FileInputPreviewType.IMAGE, FileInputPreviewType.AUDIO, FileInputPreviewType.VIDEO])) && (labels.open)}
                    </span>
                    {(!isManaging) && (<span className="re link danger" onClick={props.remove}>{labels.remove}</span>)}
                    {(isManaging) && (<span className={Classname.build("re link", { "noseur-disabled": isAccepted })} style={{ color: "#25BB4D" }} onClick={props.accept}>{isAccepted ? labels.accepted : labels.accept}</span>)}
                </div>
            </span>
            <span className="s lined-limit">{proof.size}</span>
        </div>
    </div>);

}

export default ResultProof;
